var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-navbar',{staticClass:"shadow-sm",attrs:{"toggleable":"lg","type":"light"}},[_c('b-navbar-brand',[_c('router-link',{attrs:{"to":{
      path: '/',
     
    }}},[_c('h1',{staticClass:"title is-3 is-flex-mobile"})])],1),_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('menu-component'),_c('search-component'),_c('menu-left-component')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }